import React, { useEffect, useState } from "react";
import { doc, updateDoc, getDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import ToggleButton from "../../button/ToggleButton";

interface UserEditProps {
  userId: string;
  onBack: () => void;
}

const UserEdit: React.FC<UserEditProps> = ({ userId, onBack }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [judge, setJudge] = useState(false);

  useEffect(() => {
    const fetchUser = async () => {
      const docRef = doc(db, "users", userId);

      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const data = docSnap.data();

        setName(data.name || "");
        setEmail(data.email || "");
        setRole(data.role || "");
        setJudge(data.judge || "");
      }
    };

    fetchUser();
  }, [userId]);

  const handleSave = async () => {
    if (!name.trim()) {
      alert("ユーザー名は必須です。");
      return;
    }

    await updateDoc(doc(db, "users", userId), {
      name,
      role,
      judge,
    });

    onBack();
  };

  return (
    <div className="table-contents">
      <p className="back" onClick={onBack}>
        ＜ 一覧に戻る
      </p>

      <div className="table-main">
        <div className="admin-edit">
          <div className="form-contents">
            <label className="form-label">メールアドレス</label>

            <p className="fixed-form">{email}</p>
          </div>

          <div className="form-contents middle-size">
            <label className="form-label required">ユーザー名</label>

            <input value={name} onChange={(e) => setName(e.target.value)} />
          </div>

          <div className="form-contents">
            <label className="form-label required">権限</label>

            <ToggleButton
              value={role}
              onChange={setRole}
              options={[
                {
                  label: "管理者",
                  value: "adminMaster",
                  activeClass: "selected-true",
                },
                {
                  label: "一般",
                  value: "adminUser",
                  activeClass: "selected-false",
                },
              ]}
            />
          </div>

          <div className="form-contents">
            <label className="form-label required">審査権限</label>

            <ToggleButton
              value={judge}
              onChange={setJudge}
              options={[
                { label: "あり", value: true, activeClass: "selected-true" },
                { label: "なし", value: false, activeClass: "selected-false" },
              ]}
            />
          </div>

          <div className="edit-footer">
            <button onClick={handleSave}>編集を保存する</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserEdit;
